import { useAboutPage } from '../hooks/usePublicContent';
import { Container } from '../components/ui/Container';
import { Eyebrow } from '../components/ui/Eyebrow';

export function AboutPage() {
  const { data, isLoading } = useAboutPage();

  return (
    <Container className="py-16 md:py-24 max-w-3xl">
      <Eyebrow>Our Story</Eyebrow>
      <h1 className="mt-4 font-serif text-4xl font-light text-ink md:text-5xl">About Us</h1>

      {isLoading && (
        <div className="mt-12 space-y-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="space-y-2">
              <div className="h-6 w-1/3 animate-pulse bg-stone-light/30" />
              <div className="h-24 animate-pulse bg-stone-light/30" />
            </div>
          ))}
        </div>
      )}

      {!isLoading && (!data?.content || data.content.length === 0) && (
        <p className="mt-12 text-sm text-stone">About page content coming soon.</p>
      )}

      {data?.content && data.content.length > 0 && (
        <div className="mt-12 space-y-10">
          {data.content.map((section, i) => (
            <div key={i}>
              {section.heading && (
                <h2 className="font-serif text-2xl font-light text-ink">{section.heading}</h2>
              )}
              {section.body && (
                <p className="mt-3 leading-relaxed text-stone">{section.body}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </Container>
  );
}
